const PropTypes = require('prop-types');
const React = require('react');

function SubmitButton(props) {
  const disabled = () => props.disableSubmit || false;

  return (
    <div className="align-right">
      <div className="position-relative speech-absolute inline-block align-left">
        <button
          type="submit"
          className="btn btn-success"
          disabled={disabled()}
        >
          {I18n.t('js.dashboard.selling.shippingLabels.submitButton.reviewRates')}
        </button>
      </div>
    </div>
  );
}

SubmitButton.propTypes = {
  disableSubmit: PropTypes.bool,
};

module.exports = SubmitButton;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_labels/submit_button.jsx